module.exports = __webpack_public_path__ + "static/media/nortification_register.5d5ad4c8.svg";